import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

const AdminVerifyHost = () => {
  const [hosts, setHosts] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const API = process.env.REACT_APP_API_BASE_URL;

  //Sujay 18/06/2025 adding the file to show the host for validate
  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    toolbarPlugin: {
      toolbarSlot: (slots) => {
        const { Download, ...rest } = slots;
        return { ...rest };
      },
    },
  });

  useEffect(() => {
    fetchhosts();
  }, []);

  const fetchhosts = async () => {
    try {
        //this is new api created for the to get unapproved host
      const res = await axios.get(`${API}/api/admin/unapproved-host`);
      setHosts(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleCheckbox = (id) => {
    setSelectedIds(prev =>
      prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
    );
  };

  const handleApprove = async () => {
    try {
        //use this old routes for updateing the state 
      const res = await axios.put(`${API}/api/admin/approve-hosts`, {
        Hostids: selectedIds
      });
      alert(res.data.message);
      setSelectedIds([]);
      fetchhosts(); // refresh list
    } catch (err) {
      console.error(err);
      alert('Error approving hosts');
    }
  };

  return (
    <div className="container mt-4">
      <h3 className="text-center mb-4 text-primary">Verify hosts</h3>
      {hosts.length === 0 ? (
        <div class="alert alert-info fw-bold text-center mb-3 rounded shadow-sm" role="alert">
          No unapproved hosts found.
        </div>
      ) : (
        <>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Select</th>
                <th>Hostname</th>
                <th>Email</th>
                <th>Contact</th>
                <th>Platform</th>
              </tr>
            </thead>
            <tbody>
              {hosts.map((host) => (
                <tr key={host.Hostid}>
                  <td>
                    <input
                      type="checkbox"
                      checked={selectedIds.includes(host.Hostid)}
                      onChange={() => handleCheckbox(host.Hostid)}
                    />
                  </td>
                  <td>{host.Hostname}</td>
                  <td>{host.Email}</td>
                  <td>{host.Contact}</td>
                  <td>{host.PlatformName}</td>
                  
                </tr>
              ))}
            </tbody>
          </table>
          <button
            className="btn btn-success mb-2"
            onClick={handleApprove}
            disabled={selectedIds.length === 0}
          >
            Approve Selected
          </button>
        </>
      )}
    </div>
  );
};

export default AdminVerifyHost;
